import FormControlLabel from '@material-ui/core/FormControlLabel'
import React from 'react'

export const MailLinkWrapper = (props) => {
    let queryString = ''
    let subject = props.subject
    let body = props.body

    if (subject) {
        queryString += '?subject=' + encodeURIComponent(subject)
    }
    if (body) {
        if (queryString === '') {
            queryString += '?'
        } else {
            queryString += '&'
        }
        queryString += 'body=' + encodeURIComponent(body)
    }

    return (
        <FormControlLabel
            style={{ marginLeft: 0 }}
            props={props}
            control={
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={'mailto:' + props.mail + queryString}
                >
                    {props.children}
                </a>
            }
            label=""
            labelPlacement="end"
        />
    )
}

export const WhatsAppLinkWrapper = (props) => {
    let countryPrefix = props.countryPrefix
    if (!props.countryPrefix) {
        countryPrefix = ''
    }

    return (
        <FormControlLabel
            style={{ marginLeft: 0 }}
            control={
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={
                        'https://wa.me/' +
                        countryPrefix +
                        props.mobilePhoneNumber +
                        '?text=' +
                        props.text
                    }
                >
                    {props.children}
                </a>
            }
            label=""
            labelPlacement="end"
        />
    )
}
